(function () {
  var COOKIE_ATTR = "es_crm_attribution";
  var VISITOR_COOKIE = "es_crm_visitor";
  var MAX_AGE = 60 * 60 * 24 * 90;

  function readCookie(name) {
    var match = document.cookie.match(
      new RegExp("(?:^|; )" + name + "=([^;]*)"),
    );
    if (!match) return null;
    try {
      return JSON.parse(decodeURIComponent(match[1]));
    } catch (e) {
      return null;
    }
  }

  function writeCookie(name, data) {
    document.cookie =
      name +
      "=" +
      encodeURIComponent(JSON.stringify(data)) +
      "; path=/; max-age=" +
      MAX_AGE +
      "; SameSite=Lax";
  }

  function captureFromUrl() {
    var params = new URLSearchParams(window.location.search);
    var keys = [
      "utm_source",
      "utm_medium",
      "utm_campaign",
      "utm_content",
      "utm_term",
      "gclid",
      "fbclid",
      "msclkid",
      "ttclid",
    ];
    var stored = readCookie(COOKIE_ATTR) || {};
    var changed = false;
    keys.forEach(function (key) {
      var value = params.get(key);
      if (value && !stored[key]) {
        stored[key] = value;
        changed = true;
      }
    });
    if (!stored.landing_page_url) {
      stored.landing_page_url = window.location.href;
      changed = true;
    }
    if (!stored.referrer_url && document.referrer) {
      stored.referrer_url = document.referrer;
      changed = true;
    }
    if (changed) writeCookie(COOKIE_ATTR, stored);
    return stored;
  }

  function getVisitorId() {
    var stored = readCookie(VISITOR_COOKIE);
    if (stored && stored.id) return stored.id;
    var id =
      typeof crypto !== "undefined" && crypto.randomUUID
        ? crypto.randomUUID()
        : "v-" + Date.now() + "-" + Math.random().toString(16).slice(2);
    writeCookie(VISITOR_COOKIE, { id: id });
    return id;
  }

  function applyToPayload(payload) {
    var attrs = captureFromUrl();
    var fields = Object.assign({}, payload.fields || {}, {
      gclid: (payload.fields && payload.fields.gclid) || attrs.gclid,
      fbclid: (payload.fields && payload.fields.fbclid) || attrs.fbclid,
      msclkid: (payload.fields && payload.fields.msclkid) || attrs.msclkid,
      ttclid: (payload.fields && payload.fields.ttclid) || attrs.ttclid,
    });
    return Object.assign({}, payload, {
      visitor_id: getVisitorId(),
      landing_page_url: payload.landing_page_url || attrs.landing_page_url,
      referrer_url: payload.referrer_url || attrs.referrer_url,
      utm_source: payload.utm_source || attrs.utm_source,
      utm_medium: payload.utm_medium || attrs.utm_medium,
      utm_campaign: payload.utm_campaign || attrs.utm_campaign,
      utm_content: payload.utm_content || attrs.utm_content,
      utm_term: payload.utm_term || attrs.utm_term,
      fields: fields,
    });
  }

  window.esCrmAttribution = {
    get: captureFromUrl,
    getVisitorId: getVisitorId,
    applyToFormPayload: applyToPayload,
  };
})();
